import { useMemo, useState } from 'react'

import { useTranslation } from '@flecto/translations'
import { type CoreUserAddress } from '@flecto/types'
import { BoxGoogleMaps, useMediaQuery } from '@flecto/ui'

import { useStoreAddresses } from '../../hooks/useStoreAddresses'
import { CardStoreDetails } from '../CardStoreDetails/CardStoreDetails'
import { Container } from '../Page/Container'
import styles from './styles.module.css'

export function SectionContact() {
  const { t } = useTranslation('store', { keyPrefix: 'store-shared' })
  const { isDesktop } = useMediaQuery()
  const addresses = useStoreAddresses()
  const [currentAddress, setCurrenAddress] = useState<CoreUserAddress | null>(
    addresses[0]
  )

  const marker = useMemo(
    () => ({
      lat: currentAddress?.latitude ?? 0,
      lng: currentAddress?.longitude ?? 0,
      label: currentAddress?.label ?? '',
      show: true,
    }),
    [currentAddress]
  )

  if (!currentAddress) {
    return
  }

  return (
    <BoxGoogleMaps markers={[marker]} className={styles.map}>
      <Container h={0}>
        <CardStoreDetails
          onChangeAddress={setCurrenAddress}
          className={styles.card}
          shadow='xl'
          title={t('card_store_details.title_our_locations')}
          withCollapseInfo={!isDesktop}
        />
      </Container>
    </BoxGoogleMaps>
  )
}
